import React, { useState } from 'react';
import './faqTradeSection.scss';
import FaqAccordionItemComponent from "./components/FaqAccordionItemComponent";

const FaqTradeSection = () => {
	const [activeIndex, setActiveIndex] = useState<number | null>(null);
	
	const accordionOptions = [
		{
			title: 'What are NFD Trade Bots?',
			value: 'NFD Trade Bots are bots within Telegram that allow for quick and convenient trading of any tokens' +
				' within specific networks. Currently, we support the following networks: Solana, SUI, Base, BNB Chain,' +
				' Tron, and XRP.<br/><br/>' +
				'The functionality of the bots enables users to perform regular token swaps, set limit orders, snipe liquidity migrations, automatically copy transactions of wallets you follow, configure custom RPCs, protect against MEV attacks, and much more.'
		},
		{
			title: 'Where is private information stored?',
			value: 'All private information (seed phrases, private wallets, and passwords) remains only with you after generation. We do not store this information and cannot recover it if you lose it. Always save your wallet data, as losing access to your Telegram account will result in the loss of funds stored in your wallets.<br/><br/>' +
				'If you lose access to your Telegram account but have your seed phrase or private key, you can easily regain access to your assets by importing your data into our bot using another Telegram account or any browser-based wallet.<br/><br/>' +
				'Your assets are securely protected by the password you set up when you start using our bots. Without this password, attackers will not be able to access your private information, even if they gain access to your Telegram account.<br/><br/>' +
				'Make sure to save this password. We do not store it and cannot recover it if lost!'
		},
		{
			title: "How can I ensure I'm using the original bot?",
			value: 'Always use only the official links to our bots provided on this website or through our official social media channels. Any other bots with our name are fakes, and using them will result in the loss of your assets in 100% of cases.<br/><br/>' +
				'You can always contact our support team to verify the link to the original bot. Our staff will gladly assist you and help you avoid scammers.',
		},
		{
			title: 'What is the cost of using the bot?',
			value: 'We charge 1% of the transaction amount for exchanges made within the bot. You can find more detailed information about fees on this page of our documentation.',
		},
		{
			title: 'What is the minimum amount required to start trading?',
			value: "There is no minimum amount, but make sure you have a sufficient balance to cover the network fee and the bot's trading fee.",
		},
		{
			title: 'How safe is it to use NFD Trade Bots?',
			value: 'Our team has done and continues to do everything possible to ensure that you and your assets remain secure. However, you should always stay vigilant and prevent unauthorized access to your Telegram account. For such cases, the bot is protected by a password that will prevent attackers from accessing your private information<br/><br/>' +
				'Always remember the key security rules: no member of our team will ever message you privately or request any data from your wallet. If someone contacts you pretending to be us, rest assured it’s a scam. Never share your private keys or seed phrases with anyone, and always double-check that you are using the original bot, not a fake.',
		},
		{
			title: 'Will the bot continue to operate if my device is turned off?',
			value: "Yes, all processes within the bot will continue because they run on the bot's server, not on your device. Therefore, scrappers, limit orders, and other bot features will continue to function autonomously.",
		},
	];
	
	const handleItemClick = (index: number) => {
		setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
	};
	
	return (
		<div className="faqTradeSection">
			<div className="faqTradeSection__content">
				<div className="faqTradeSection__content_title">
					<h3>FAQ</h3>
				</div>
				<div className="faqTradeSection__content_accordion">
					{accordionOptions.map((item, index) => (
						<FaqAccordionItemComponent
							key={index}
							title={item.title}
							value={item.value}
							isOpen={activeIndex === index}
							onClick={() => handleItemClick(index)}
						/>
					))}
				</div>
			</div>
		</div>
	);
};

export default FaqTradeSection;